import { ROUTE_NAMES } from '@atlassian/jira-common-constants/src/spa-routes';

export const PROJECTS_SETTINGS_ROUTE_NAMES = new Set<string>([
	ROUTE_NAMES.ARCHIVED_PROJECTS_DIRECTORY,
	ROUTE_NAMES.GLOBAL_SETTINGS_PROJECTS_CATEGORIES_VIEW,
	ROUTE_NAMES.PROJECTS_DIRECTORY_LEGACY_PATH_SPA,
	ROUTE_NAMES.PROJECTS_DIRECTORY_MANAGE,
	ROUTE_NAMES.TRASH_PROJECTS_DIRECTORY,
]);
